export const formBuilderInputTypes = {
  GROUP: 'Group',
  LABEL: 'Label',
  USER: 'UserDropdown',
  SUB_GROUP: 'SubGroup',
  CHECK_BOX: 'CheckBox',
  LOV_INPUT: 'LovInput',
  TEXT_INPUT: 'TextInput',
  ENUM_INPUT: 'EnumInput',
  VERTEX_PANEL: 'VertexPanel',
  EXPORT_BUTTON: 'ExportButton',
  GROUP_DROPDOWN: 'GroupDropdown',
  PO_MATCH_BUTTON: 'PoMatchButton',
  MULTI_CHECK_BOX: 'MultiCheckBox',
  LINE_ITEM_TABLE: 'LineItemTable',
  EXTRACTED_TABLE: 'ExtractedTable',
  INVOICE_BUTTONS: 'InvoiceButtons',
  SAVE_RULES_BUTTON: 'SaveRulesButton',
  AI_EXTRACTED_TABLE: 'AIExtractedTable',
  TABLE_OF_CHECKBOXES: 'TableOfCheckboxes',
  AMOUNT_BUTTONS_PANEL: 'AmountButtonsPanel',
  HORIZONTAL_SEPARATOR: 'HorizontalSeparator',
  REJECT_DOCUMENT_BUTTON: 'RejectDocument',
  AUTO_ACCOUNTING_BUTTON: 'AutoAccountingButton',
  QR_CODE_EXTRACTED_FIELDS: 'QRCodeExtractedFields',
  EXTRACTED_TABLE_TAB_PANELS: 'ExtractedTableTabPanels',
  EXPORT_WITHOUT_VALIDATION_BUTTON: 'ExportWithoutValidation',
  ADITIONAL_AMOUNT_BUTTONS_PANEL: 'AditionalAmountButtonsPanel',
  // Approval-specific element types
  NOTES: 'Notes',
  BUTTON: 'Button',
  CORRECTION_BUTTONS: 'CorrectionButtons',
  DOCUMENT_APPROVER: 'DocumentApprover',
  SECOND_APPROVER: 'SecondApprover',
  AUTO_ACCOUNTING_SECTION: 'AutoAccountingSection',
  QUOTE_COMPARE_LINES: 'QuoteCompareLines',
};
export const FORM_BUILDER_CONSTANTS = {
  additionalAmountInRow: 3,
  amountPanelField: [
    'net_amount',
    'tax_amount',
    'tax_rate',
    'tax_code',
    'net_amount_2',
    'tax_amount_2',
    'tax_rate_2',
    'tax_code_2',
    'net_amount_3',
    'tax_amount_3',
    'tax_rate_3',
    'tax_code_3',
    'total_net_amount',
    'total_tax_amount',
  ],
  aditionalAmountFields: [
    'additional_amount',
    'additional_amount_2',
    'additional_amount_3',
    'negative_amount',
    'negative_amount_2',
    'negative_amount_3',
  ],
  amountGroup1: ['net_amount', 'tax_amount', 'tax_rate', 'tax_code'],
  amountGroup2: ['net_amount_2', 'tax_amount_2', 'tax_rate_2', 'tax_code_2'],
  amountGroup3: ['net_amount_3', 'tax_amount_3', 'tax_rate_3', 'tax_code_3'],
  aditionalAmountGroupPositive: [
    'additional_amount',
    'additional_amount_2',
    'additional_amount_3',
    'shipping_charges',
  ],
  aditionalAmountGroupNegative: [
    'negative_amount',
    'negative_amount_2',
    'negative_amount_3',
  ],
};

export const allowAbleModels = [
  'CheckBox',
  'TextInput',
  'EnumInput',
  'MultiCheckBox',
  'TableOfCheckboxes',
];

export const articleNumber = 'article_number';

export const tableBodyRows = [
  {
    isLabelArea: true,
    label: 'mediven elegance',
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
  {
    fieldType: 'CheckBox',
    isLabelArea: false,
    isDisabled: false,
    name: '',
    value: false,
    content: false,
    formatted_value: false,
  },
];
